import dateFormat from "dateformat";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const PrintSource = props => {
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs("p", {
      children: ["This map was created using", " ", /*#__PURE__*/_jsx("a", {
        href: window.location.origin,
        children: window.location.origin
      }), " on", " ", dateFormat()]
    }), /*#__PURE__*/_jsxs("p", {
      children: ["An interactive version of this map can be found here:", " ", /*#__PURE__*/_jsx("a", {
        href: props.link,
        children: props.link
      })]
    })]
  });
};
export default PrintSource;